import { postApi } from "./api_instance";

export const retirePopupPost = async ( formData, dispatch) => {
  try {
    return await postApi({
      apiUrl: "/projects/api/retirements/add-retirement",
      dispatch,
      sendToken: true,
      data: formData, 
    });
  } catch (error) {
    throw error;
  }
};
